import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "kt_header",
  style: {},
  class: "header align-items-stretch"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center d-lg-none ms-n3 me-1",
  title: "Show aside menu"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-active-light-primary",
    id: "kt_aside_mobile_toggle"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x mt-1 opacity-30" }, [
      /*#__PURE__*/_createElementVNode("img", { src: "media/icons/duotune/abstract/abs015.svg" })
    ])
  ])
], -1)
const _hoisted_3 = { class: "d-flex align-items-center flex-grow-1 flex-lg-grow-0" }
const _hoisted_4 = {
  href: "#",
  class: "d-lg-none"
}
const _hoisted_5 = {
  key: 0,
  src: "media/logos/logo-1.svg"
}
const _hoisted_6 = {
  key: 1,
  src: "https://www.hko.gov.hk/images/logo_hko_inside_c.png",
  class: ""
}
const _hoisted_7 = { class: "d-flex align-items-stretch justify-content-between flex-lg-grow-1" }
const _hoisted_8 = {
  class: "d-flex align-items-stretch",
  id: "kt_header_menu_nav"
}
const _hoisted_9 = { class: "d-flex align-items-stretch flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTMenu = _resolveComponent("KTMenu")!
  const _component_KTTopbar = _resolveComponent("KTTopbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }, "d-flex align-items-stretch justify-content-between"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          (!_ctx.chkDev())
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.chkDev())
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_KTMenu)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_KTTopbar)
        ])
      ])
    ], 2)
  ]))
}